import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import useTranslation from "../../mlang/useTranslation"
import withLayout from "../../components/layout/withLayout"
import SEO from "../../components/seo"
import HeaderEquip from "../../components/equipment/headerEquip"
import EquipTable from "../../components/equipment/equipTable"


const InfracutQcw = () => {
  const equip = useTranslation('infracut-qcw')

  const { file: { image } } = useStaticQuery(graphql`
  {
    file(relativeDirectory: {eq: "special"}, name: {eq: "infracut-qcw"}) {
      image: childImageSharp {
        fluid(quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }`)
  
  return (
    <div className="page">
      <SEO title={equip.title} />
      <HeaderEquip equip={equip} image={image} />
      <EquipTable data={equip.specifications} />
      <EquipTable data={equip.capability} />
    </div>
  )
}

export default withLayout(InfracutQcw)
